module.exports = __webpack_public_path__ + "img/icon-data-application.c80ea89e.svg";